<template>
    <section>
        <Sidebar />
        <Content>
            <template v-if="1 == 2">
                <div class="field" style="float: left; margin-top: 3px; margin-right: 3px;">
                    <b-switch :value="true" type="is-success"></b-switch>
                </div>
            </template>
            <h1 style="float: left;">{{endpoint.name}}</h1>
             <b-button type="is-success" style="float: right" loading v-if="waitingRunTest == true">
                Run <i class="fas fa-play" style="font-size: 12px; margin-left: 2px;"></i>
            </b-button>
            <b-button @click="runTest($route.params.test_id)" type="is-success" style="float: right" v-else>
                Run <i class="fas fa-play" style="font-size: 12px; margin-left: 2px;"></i>
            </b-button>
            <b-button @click="updateTest()" type="is-default" style="float: right; margin-right: 15px;">
                Edit
            </b-button>
            <div id="chart">
                <template v-if="loadingGraph">
                    <img src="/img/loading-devect.gif" style="width: 100px; height: 100px; position: absolute; top: 50%; left: 50%; margin-left: -50px; margin-top: -50px;">
                </template>
                <template v-else>
                    <span v-if="is_results_empty" class="no-checks-yet">No checks yet.</span>
                    <template v-if="!is_results_empty">
                        <apexchart type=bar height=275 :options="chartOptions" :series="series" />
                    </template>
                </template>
            </div>
            <h2 style="font-size: 17px; font-weight: 200; margin-top: 30px; margin-bottom: 15px;">
                <i class="fas fa-clipboard-check"></i> Test cases
            </h2>
            <template v-if="loadingTestcases">
                <div style="position: relative; padding-top: 50px; margin-top: 100px;"><img src="/img/loading-devect.gif" style="width: 100px; height: 100px; position: absolute; top: 50%; left: 50%; margin-left: -50px; margin-top: -50px;"></div>
            </template>
            <template v-else>
                <template v-for="testcase in testcases">
                    <div class="testcase-box" :id="'testcase-' + testcase.id" :key="testcase.id" style="border-left: 5px solid #d9dddf">
                        <div class="row">
                            <div class="col-xs-2" @click="goToTestCaseEdit(testcase.id)">
                                <span class="method">{{methodToText(testcase.method)}}</span>
                            </div>
                            <div class="col-xs-8" style="padding-left: 0px;" @click="goToTestCaseEdit(testcase.id)">
                                <span class="url">{{testcase.pretty_url}}</span>
                            </div>
                            <div class="col-xs-2 button-col">
                                <b-button style="float: left;" type="is-default" size="is-small" @click="goToLogs(testcase.id)">
                                    <i class="far fa-file-alt"></i> Logs
                                </b-button>
                                <b-button style="float: right;" type="is-danger" size="is-small" @click="confirmDeleteTestCase(testcase.id)">Delete</b-button>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="add-test-case" @click="createNewTestCase()">+</div>
            </template>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import constants from "../constants"
import APITestBox from "../components/APITestBox"
import APITestUpdateModal from "../components/APITestUpdateModal"
import {getEndpoint, getAPITestGraph, checkAPITest, updateEndpoint} from "../logic/endpoints"
import {getTestCases, methodToText, getTestCaseChecks, getTestCaseStatus, deleteTestCase} from '../logic/testcase'

let endpoint = {}
let results = []
let testcases = []
let is_results_empty = true

export default {
    name: 'APITestSingle',
    components: {Sidebar, Content, APITestBox},
    data() {
        return {
            loadingGraph: true,
            loadingTestcases: true,
            waitingRunTest: false,
            testcases: testcases,
            is_results_empty: is_results_empty,
            results: results,
            series: [
               /*{name: 'Passes', data: [255, 339, 341, 280, 324, 252, 308, 206, 275, 297, 343, 278, 246, 284, 306]},
                {name: 'Errors', data: [5, 3, 13, 7, 0, 2, 10, 13, 11, 6, 1, 17, 9, 14, 16]}*/
            ],
            chartOptions: {
                grid: {
                    padding: {left: 0, right: 0, top: 0, bottom: 0}
                },
                colors: ["#8bc34a", "#F44336"],
                chart: {
                    stacked: true,
                    toolbar: {show: false},
                    zoom: {enabled: false}
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {horizontal: false,},
                },
                yaxis: {show: false,},
                xaxis: {
                    type: 'datetime',
                    labels: {show: false,},
                    categories: [],
                },
                legend: {position: 'right', offsetY: 40, show: false},
                fill: {opacity: 1},
                dataLabels: {
                    enabled: true,
                    style: {fontSize: '10px', fontFamily: 'Helvetica, Arial, sans-serif'},
                },
                tooltip: {
                    y: {
                        formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                            return parseInt(value)
                        }
                    }
                }
            },
            endpoint: endpoint
        }
    },
    methods: {
        methodToText: methodToText,
        deleteTestCase: deleteTestCase,
        confirmDeleteTestCase(testcase_id) {
            let _this = this;
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to delete this Test Case?',
                onConfirm: () => {
                    deleteTestCase(_this.$route.params.test_id, testcase_id).then(response => {
                        _this.showSuccessMsg("Test Case deleted successfully", "is-success")
                        _this.getTestCases()
                    }).catch(error => {
                        _this.showSuccessMsg("Something went wrong. We could not delete the Test Case", "is-danger")
                    })
                }
            })
        },
        updateTest: function(){
            let _this = this;
            this.$buefy.modal.open({
                parent: _this,
                component: APITestUpdateModal,
                hasModalCard: true,
                props: {
                    endpoint: _this.endpoint
                },
                events: {
                    'updated-test': apitest => {
                        updateEndpoint(_this.$route.params.test_id, apitest).then(response => {
                            _this.showSuccessMsg("API Test updated successfully", "is-success")
                        }).catch(error => {
                            _this.showSuccessMsg("Something went wrong. We could not update the API Test", "is-danger")
                        })
                    }
                }
            })
        },
        getTest: function(){
            getEndpoint(this.$route.params.test_id).then(response => {
                this.endpoint = response.data
            })
        },
        showSuccessMsg: function(message, msg_type){
            this.$buefy.toast.open({message: message, type: msg_type})
        },
        goToLogs: function(testcase_id){
            let test_id = this.$route.params.test_id
            this.$router.push({
                name: 'api-test-case-logs',
                params: {'test_id': test_id, 'testcase_id': testcase_id}
            })
        },
        getTestCases: function(){
            let _this = this;
            let test_id = this.$route.params.test_id
            getTestCases(test_id).then(response => {
                _this.testcases = response.data.results
                for(let i = 0; i < _this.testcases.length; i++){
                    getTestCaseStatus(test_id, _this.testcases[i].id).then(response => {
                        let result = response.data;
                        let _id = 'testcase-' + _this.testcases[i]["id"]

                        if(result["failed"] == 0){
                            document.getElementById(_id).classList.add('success');
                        }else{
                            let ratio = 100 - ((result["failed"]/result["success"]) * 100)
                            if(ratio >= constants.RATIO_WARNING){
                                document.getElementById(_id).classList.add('warning');
                            }else{
                                document.getElementById(_id).classList.add('failed');
                            }
                        }
                    })
                }
                _this.loadingTestcases = false;
            }).catch(error => {
                console.log(error)
                _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
        },
        goToTestCaseEdit: function(testcase_id){
            this.$router.push({
                name: 'api-test-case-edit',
                params: {'test_id': this.$route.params.test_id, 'testcase_id': testcase_id}
            })
        },
        createNewTestCase: function(){
            this.$router.push({name: 'api-test-case-create', params: {'test_id': this.$route.params.test_id}})
        },
        runTest: function(test_id){
            let _this = this
            _this.waitingRunTest = true
            checkAPITest(test_id).then(response => {
                let result = response.data;
                let reset_ids = []

                for(let i = 0; i < _this.testcases.length; i++){
                    let _id = 'testcase-' + _this.testcases[i]["id"]
                    reset_ids.push(_id)
                    if(result.success.includes(_this.testcases[i]["id"])){
                        document.getElementById(_id).classList.add('animate-success');
                    }
                    if(result.errors.includes(_this.testcases[i]["id"])){
                        document.getElementById(_id).classList.add('animate-error');
                    }
                }

                setTimeout(function(){
                    for(let i = 0; i<reset_ids.length; i++){
                        document.getElementById(reset_ids[i]).classList.remove('animate-success');
                        document.getElementById(reset_ids[i]).classList.remove('animate-error');
                    }
                }, 2500)

                _this.getTestCases()
                _this.waitingRunTest = false;
            })
        },
        getGraph: function(){
            getAPITestGraph(this.$route.params.test_id).then(response => {
                let failed = []
                let success = []
                let keys = []

                for(let key in response.data){
                    success.push(response.data[key].success)
                    failed.push(response.data[key].failed)
                    keys.push(key)
                }

                this.chartOptions.xaxis.categories = keys.reverse()
                this.series.push(
                    {name: 'Passes', data: success.reverse()},
                    {name: 'Errors', data: failed.reverse()}
                )
                this.loadingGraph = false;
                this.is_results_empty = false
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. We could not load the graph", "is-danger")
            })
        },
    },
    mounted: function(){
        this.getTest()
        this.getTestCases()
        this.getGraph()
    }
}
</script>

<style scoped>
    h1{margin-bottom: 24px;}
    .testcase-box{
        background: #fff;
        margin-bottom: 15px;
        border: 1px solid #d9dddf;
        padding: 15px 25px;
        cursor: pointer;
        position: relative;
    }
    .testcase-box.success{
        border-left: 5px solid rgb(139, 195, 74) !important;
    }
    .testcase-box.failed{
        border-left: 5px solid #F44336 !important;
    }
    .testcase-box.warning{
        border-left: 5px solid #FFC107 !important;
    }
    .testcase-box.animate-success{
        background: #8bc34a99;
    }
    .testcase-box.animate-success::after{
        font-family: "Font Awesome 5 Free";
        content: "\f00c";
        background: #fff;
        width: 40px;
        border-radius: 100%;
        display: block;
        height: 40px;
        line-height: 40px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 9px;
        margin-left: -20px;
        z-index: 999;
        font-weight: 900;
    }
    .testcase-box.animate-success::before{
        content: "";
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 99;
        background: #8bc34ab8;
    }
    .testcase-box.animate-error::after{
        font-family: "Font Awesome 5 Free";
        content: "\f00d";
        background: #fff;
        width: 40px;
        border-radius: 100%;
        display: block;
        height: 40px;
        line-height: 40px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 9px;
        margin-left: -20px;
        font-weight: 900;
        z-index: 999;
    }
    .testcase-box.animate-error::before{
        content: "";
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 99;
        background: #f44336d9;
    }
    #chart{
        clear: both;
        background: white;
        height: 260px;
        position: relative;
        overflow: hidden;
        border: 1px solid #d9dddf;
        padding-left: 2px;
    }
    .no-checks-yet{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -54px;
        margin-top: -12px;
    }
    .add-test-case{
        cursor: pointer;
        background: #fff;
        padding: 5px;
        font-size: 30px;
        font-weight: 200;
        text-align: center;
        border: 1px solid #d9dddf;
        margin-top: 20px;
    }
    @media (max-width: 1165px) {
        .button-col .button{
            width: 100%;
            margin: 2.5px 0px;
        }
    }

</style>